import { render, staticRenderFns } from "./LungSoundEffect.vue?vue&type=template&id=529faee6&scoped=true&"
import script from "./LungSoundEffect.vue?vue&type=script&lang=js&"
export * from "./LungSoundEffect.vue?vue&type=script&lang=js&"
import style0 from "./LungSoundEffect.vue?vue&type=style&index=0&id=529faee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529faee6",
  null
  
)

export default component.exports